/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Scene_Change_Detection_Marker_CommentInputs */



/**
* | output |
* | --- |
* | "Shot Change {number}" |
*
* @param {Scene_Change_Detection_Marker_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_marker_comment = /** @type {((inputs: Scene_Change_Detection_Marker_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Marker_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Changement de plan ${i?.number}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Schusswechsel ${i?.number}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Cambio di tiro ${i?.number}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Смена кадра ${i?.number}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Cambio de tiro ${i?.number}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`投篮变化${i?.number}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ショットチェンジ ${i?.number}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शॉट परिवर्तन ${i?.number}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Troca de dose ${i?.number}`)
	return /** @type {LocalizedString} */ (`Shot Change ${i?.number}`)
});